import PeopleIcon from '@mui/icons-material/People'
import GridOnIcon from '@mui/icons-material/GridOn';
import DashboardIcon from '@mui/icons-material/Dashboard'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import PhotoFilterIcon from '@mui/icons-material/PhotoFilter'
import PaymentIcon from '@mui/icons-material/Payment';
import CellTowerIcon from '@mui/icons-material/CellTower';
import FlareIcon from '@mui/icons-material/Flare'
import RadioIcon from '@mui/icons-material/Radio';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText'
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import WidgetsIcon from '@mui/icons-material/Widgets'
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import TollIcon from '@mui/icons-material/Toll'
import PriceCheckIcon from '@mui/icons-material/PriceCheck'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import CastIcon from '@mui/icons-material/Cast'
import ReceiptIcon from '@mui/icons-material/Receipt'
import SummarizeIcon from '@mui/icons-material/Summarize'
import NotificationAddIcon from '@mui/icons-material/NotificationAdd'
import AltRouteIcon from '@mui/icons-material/AltRoute';
import PublicIcon from '@mui/icons-material/Public'
import EmailIcon from '@mui/icons-material/Email'
import SettingsIcon from '@mui/icons-material/Settings'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt'
import CampaignIcon from '@mui/icons-material/Campaign'
import RssFeedIcon from '@mui/icons-material/RssFeed'
import SellIcon from '@mui/icons-material/Sell'
import GTranslateIcon from '@mui/icons-material/GTranslate';
import QuizIcon from '@mui/icons-material/Quiz'
import StarRateIcon from '@mui/icons-material/StarRate'
import TuneIcon from '@mui/icons-material/Tune'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AdUnitsIcon from '@mui/icons-material/AdUnits'
import BusinessIcon from '@mui/icons-material/Business'
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi'
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining'
import CategoryIcon from '@mui/icons-material/Category'
import InventoryIcon from '@mui/icons-material/Inventory'
import SubscriptionsIcon from '@mui/icons-material/Subscriptions'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ShareIcon from '@mui/icons-material/Share'
import CalculateIcon from '@mui/icons-material/Calculate'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import DiscountIcon from '@mui/icons-material/Discount'
export const sidebarNav = [
  // Dashboard
  {
    moduleId: '1',
    name: 'Dashboard',
    path: '/',
    icon: <DashboardIcon className='margin-right-1-rem' />
  },

  // System Management
  {
    moduleId: '13',
    name: 'Global Settings',
    path: '/global-setting-manager',
    icon: <SettingsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '20',
    name: 'Role Manager',
    path: '/role-manager',
    icon: <TuneIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '3',
    name: 'Sub Admin Manager',
    path: '/sub-admin-manager',
    icon: <AdminPanelSettingsIcon className='margin-right-1-rem' />
  },

  // User Management
  {
    moduleId: '2',
    name: 'User Manager',
    path: '/user-manager',
    icon: <PeopleIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '32',
    name: 'Influencer Manager',
    path: '/influencer-manager',
    icon: <AccessibilityNewIcon className='margin-right-1-rem' />
  },

  // Business Management
  {
    moduleId: '21',
    name: 'Business Category Manager',
    path: '/business-category-manager',
    icon: <BusinessIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '22',
    name: 'Merchant Manager',
    path: '/business-merchant-manager',
    icon: <BusinessIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '23',
    name: 'Agents Manager',
    path: '/agents-manager',
    icon: <PeopleIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '24',
    name: 'Agency Manager',
    path: '/agency-manager',
    icon: <BusinessIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '25',
    name: 'Rider Manager',
    path: '/riders-manager',
    icon: <DeliveryDiningIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '26',
    name: 'Affiliate Manager',
    path: '/affiliate-user-manager',
    icon: <DeliveryDiningIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '27',
    name: 'Vehicle Category Manager',
    path: '/vehicle-category-manager',
    icon: <LocalTaxiIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '28',
    name: 'Merchant Rider Subscription',
    path: '/merchant-rider-subscription-manager',
    icon: <SubscriptionsIcon className='margin-right-1-rem' />
  },

  // Product & Inventory Management
  {
    moduleId: '29',
    name: 'Product Category Manager',
    path: '/product-category-manager',
    icon: <CategoryIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '30',
    name: 'Product Manager',
    path: '/product-manager',
    icon: <InventoryIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '49',
  //   name: 'Discount Vouchers',
  //   path: '/discount-vouchers-manager',
  //   icon: <DiscountIcon className='margin-right-1-rem' />
  // },
  {
    moduleId: '51',
    name: 'Discount Voucher Config',
    path: '/discount-voucher-config',
    icon: <SettingsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '50',
    name: 'Product Discount List',
    path: '/product-discount-list',
    icon: <PriceCheckIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '29',
    name: 'Service Manager',
    path: '/service-manager',
    icon: <InventoryIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '48',
  //   name: 'VOD Manager',
  //   path: '/vod-manager',
  //   icon: <InventoryIcon className='margin-right-1-rem' />
  // },

  // Geographic Management
  {
    moduleId: '11',
    name: 'Country Manager',
    path: '/country-manager',
    icon: <PublicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '33',
    name: 'State Manager',
    path: '/state-manager',
    icon: <LocationOnIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '34',
    name: 'City Manager',
    path: '/city-manager',
    icon: <LocationOnIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '35',
    name: 'District Manager',
    path: '/district-manager',
    icon: <LocationOnIcon className='margin-right-1-rem' />
  },

  // Financial Management
  {
    moduleId: '31',
    name: 'Tax Templates Manager',
    path: '/tax-templates-manager',
    icon: <CalculateIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '8',
  //   name: 'Chips Purchase Manager',
  //   path: '/beads-purchase-manager',
  //   icon: <PriceCheckIcon className='margin-right-1-rem' />
  // },
  {
    moduleId: '8',
    name: 'Transaction Manager',
    path: '/transaction-manager',
    icon: <ReceiptIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '36',
    name: 'In App Purchase Manager',
    path: '/app_packages-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '37',
    name: 'Subscription Manager',
    path: '/subscription-package',
    icon: <SubscriptionsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '39',
    name: 'Viewer Subscription Manager',
    path: '/viewer-subscription-manager',
    icon: <PeopleIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '38',
    name: 'Payment Gateway Manager',
    path: '/payment-gateway-manager',
    icon: <PaymentIcon className='margin-right-1-rem' />
  },

  // Content Management
  {
    moduleId: '7',
    name: 'Video Manager',
    path: '/video-manager',
    icon: <VideoLibraryIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '39',
    name: 'Video Upload Manager',
    path: '/video-upload-manager',
    icon: <CloudUploadIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '4',
    name: 'Sound Manager',
    path: '/sound-manager',
    icon: <LibraryMusicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '40',
    name: 'Meishe Assets Manager',
    path: '/meishe-assets-manager',
    icon: <PhotoFilterIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '19',
    name: 'Banner Manager',
    path: '/banner-manager',
    icon: <AdUnitsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '16',
    name: 'Category Manager',
    path: '/tag-manager',
    icon: <CategoryIcon className='margin-right-1-rem' />
  },

  // Radio & Live Management
  {
    moduleId: '41',
    name: 'Radio Category Manager',
    path: '/live-feed-category-manager',
    icon: <CategoryIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '42',
    name: 'Radio Manager',
    path: '/radio-manager',
    icon: <RadioIcon className='margin-right-1-rem' />
  },

  // Communication & Marketing
  {
    moduleId: '10',
    name: 'Notification Manager',
    path: '/notification-manager',
    icon: <NotificationAddIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '12',
    name: 'Email Templates',
    path: '/email-manager',
    icon: <EmailIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '15',
    name: 'Ads Management',
    path: '/ads-manager',
    icon: <CampaignIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '43',
    name: 'Ayrshare Manager',
    path: '/Ayrshare-manager',
    icon: <ShareIcon className='margin-right-1-rem' />
  },

  // System Utilities
  {
    moduleId: '44',
    name: 'Language Manager',
    path: '/language-manager',
    icon: <GTranslateIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '45',
    name: 'Network Provider Manager',
    path: '/network-provider-manager',
    icon: <CellTowerIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '46',
    name: 'Routing Manager',
    path: '/add-routing-config',
    icon: <AltRouteIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '47',
    name: 'Bot Manager',
    path: '/bot-manager',
    icon: <SmartToyIcon className='margin-right-1-rem' />
  },

  // Support & Documentation
  {
    moduleId: '5',
    name: 'Report & Abuse Manager',
    path: '/report-abuse-manager',
    icon: <ReportProblemIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '17',
    name: 'FAQ Manager',
    path: '/faq-manager',
    icon: <QuizIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '14',
    name: 'Static Content',
    path: '/static-content-manager',
    icon: <FileCopyIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '52',
    name: 'Merchant Subscription Plans',
    path: '/merchant-subscription-plans',
    icon: <FileCopyIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '53',
    name: 'Search OTP',
    path: '/search-otp',
    icon: <FileCopyIcon className='margin-right-1-rem' />
  }
]
